import React from 'react';
import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Warning = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Warning} />;

export default Warning;
